import React, { useRef, useContext } from 'react';
import PropTypes from 'prop-types';
import { Col } from '@thd-olt-component-react/grid';
import { CheckAvailabilityContext } from '../../../CheckAvailabilityContext';
import './input-form.scss';

export const InputForm = (props) => {
  const { onSubmit } = props;
  const {
    inputHeaderTitle,
    zip,
    onInputChange,
    inputButtonDisabled
  } = useContext(CheckAvailabilityContext);

  const inputElement = useRef(null);

  return (
    <div className="input-form">
      { inputHeaderTitle
        && (
          <Col nopadding className="input-form__header-title">
            <b>{inputHeaderTitle}</b>
          </Col>
        )}
      <Col nopadding>
        <form
          className="check-availability__zip-code-wrapper"
          onSubmit={onSubmit}
        >
          <Col fallback="8" nopadding>
            <span className="form-input">
              <input
                ref={inputElement}
                type="tel"
                pattern="[0-9]*"
                placeholder="Tell us your ZIP Code"
                maxLength="5"
                className="form-input__field"
                id="check-availability__zip-code"
                name="check-availability__zip-code"
                autoComplete="off"
                onChange={onInputChange}
                value={zip}
              />
            </span>
          </Col>
          <Col fallback="4" nopadding>
            <button
              type="submit"
              disabled={inputButtonDisabled}
              data-testid="check-avail-bttn"
              className="bttn-outline bttn-outline--primary"
            >
              <span role="button" tabIndex={0} className="bttn__content">Check</span>
            </button>
          </Col>
        </form>
      </Col>
    </div>
  );
};

InputForm.propTypes = {
  onSubmit: PropTypes.func
};

InputForm.defaultProps = {
  onSubmit: null
};